import React from "react"

const Error=()=>{
    return(
        <div>
            Error ! page Not found
        </div>
    )
}

export default Error